<header mat-dialog-title>
  {{'PERMISSIONS.DIALOG.TITLE' | translate}}
</header>
<section mat-dialog-content>
  <wk-permission-manager [nodeId]="nodeId"></wk-permission-manager>
</section>
<footer mat-dialog-actions>
  <button mat-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>
    {{'PERMISSIONS.DIALOG.CLOSE' | translate}}
  </button>
</footer>
